module.exports = __webpack_public_path__ + "media/assets/consultation/platform_desktop-e6383a7a63d083cbee2cd11912922360.svg";